import ICommand from '../../../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../../../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../../../FrontApplet/FrontApplet';
import {
	ManagementScreenGetBrightnessRequest,
	ManagementScreenGetBrightnessResult,
	ManagementScreenGetOrientationRequest,
	ManagementScreenGetOrientationResult,
	ManagementScreenIsPoweredOnRequest,
	ManagementScreenIsPoweredOnResult,
	ManagementScreenPowerOffRequest,
	ManagementScreenPowerOffResult,
	ManagementScreenPowerOnRequest,
	ManagementScreenPowerOnResult,
	ManagementScreenRequests,
	ManagementScreenResizeRequest,
	ManagementScreenResizeResult,
	ManagementScreenSetBrightnessRequest,
	ManagementScreenSetBrightnessResult,
	ManagementScreenTakeScreenshotRequest,
	ManagementScreenTakeScreenshotResult,
} from './screenCommands';

export function handleManagementScreenRequests(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<ManagementScreenRequests>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<ManagementScreenRequests>) => {
		switch (commandEvent.command.type) {
			case ManagementScreenResizeRequest:
				await frontApplet.management.screen.resize(
					commandEvent.command.baseUrl,
					commandEvent.command.orientation,
					commandEvent.command.resolution,
					commandEvent.command.currentVersion,
					commandEvent.command.videoOrientation,
				);
				await dispatch<ManagementScreenResizeResult>({
					type: ManagementScreenResizeResult,
					result: {},
				});
				break;
			case ManagementScreenGetOrientationRequest:
				await dispatch<ManagementScreenGetOrientationResult>({
					type: ManagementScreenGetOrientationResult,
					result: await frontApplet.management.screen.getOrientation(),
				});
				break;
			case ManagementScreenSetBrightnessRequest:
				await frontApplet.management.screen.setBrightness(
					commandEvent.command.timeFrom1,
					commandEvent.command.brightness1,
					commandEvent.command.timeFrom2,
					commandEvent.command.brightness2,
				);
				await dispatch<ManagementScreenSetBrightnessResult>({
					type: ManagementScreenSetBrightnessResult,
					result: {},
				});
				break;
			case ManagementScreenGetBrightnessRequest:
				await dispatch<ManagementScreenGetBrightnessResult>({
					type: ManagementScreenGetBrightnessResult,
					result: await frontApplet.management.screen.getBrightness(),
				});
				break;
			case ManagementScreenTakeScreenshotRequest: {
				const data = await frontApplet.management.screen.takeAndUploadScreenshot(
					commandEvent.command.uploadBaseUrl,
					commandEvent.command.computeHash,
				);
				await dispatch<ManagementScreenTakeScreenshotResult>({
					type: ManagementScreenTakeScreenshotResult,
					screenshotUrl: data.screenshotUrl,
					aHash: data.aHash,
				});
				break;
			}
			case ManagementScreenPowerOnRequest:
				await frontApplet.management.screen.powerOn();
				await dispatch<ManagementScreenPowerOnResult>({
					type: ManagementScreenPowerOnResult,
					result: {},
				});
				break;
			case ManagementScreenPowerOffRequest:
				await frontApplet.management.screen.powerOff();
				await dispatch<ManagementScreenPowerOffResult>({
					type: ManagementScreenPowerOffResult,
					result: {},
				});
				break;
			case ManagementScreenIsPoweredOnRequest:
				await dispatch<ManagementScreenIsPoweredOnResult>({
					type: ManagementScreenIsPoweredOnResult,
					result: await frontApplet.management.screen.isPoweredOn(),
				});
				break;
			default:
		}
	});
}
